export default "__VITE_ASSET___Hk4Oezc__"